import React from "react";

import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

import data from "@src/data/data.json";
import { SidebarItem } from "./SidebarItem";
import { Button } from "@src/components/Button/Button";
import Out from "@src/assets/icons/out.png";
import { SidebarProps } from "./Sidebar.props";
import { selectAuthLoader } from "@src/store/auth/selector";
import { drawerHead, getPrivateNavigations } from "./generator";
import { CustomDrawer } from "@src/components/Drawer/Drawer";
import { Typography } from "@mui/material";

export const AppSidebar: React.FC<SidebarProps> = (props): JSX.Element => {
  const { open, toggleDrawer, language } = props;
  const authLoader = useSelector(selectAuthLoader);
  const userName = localStorage.getItem("username") || "";

  const [activeNav, setActiveNav] = React.useState(0);

  const handleClassName = (isActive: boolean, id: number): string => {
    if (isActive) {
      setActiveNav(id);
    }
    return "";
  };
  const onSignOut = (): void => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("username");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("currLocation");
    window.location.href = "/";
  };

  const userRole: string[] =
    JSON.parse(localStorage.getItem("userRole") || "[]") || "";

  return (
    <CustomDrawer variant="permanent" open={open} sx={{ position: "relative" }}>
      {!authLoader ? (
        <React.Fragment>
          <Box p={`40px 0 0 0`}>
            <Box display="flex" alignItems="center" ml="4px">
              <IconButton onClick={toggleDrawer}>
                <img src={drawerHead.menu} alt="" width="24px" height="24px" />
              </IconButton>
              <Box ml="20px" display="flex" alignItems="center">
                <img
                  src={drawerHead.kwaaka}
                  alt=""
                  width="150px"
                  height="26px"
                />
              </Box>
            </Box>

            <Box mt="50px">
              {getPrivateNavigations(language)
                .filter((nav) => {
                  if (nav.id === 0 && userName === "bahandi.manager")
                    return true;
                  if (nav.id === 0 && userRole?.includes("Location-manager"))
                    return false;
                  return (
                    userRole &&
                    userRole?.some((role) => nav.role.includes(role))
                  );
                })
                .map((nav) => (
                  <SidebarItem
                    key={nav.id}
                    nav={nav}
                    navType={nav.nav}
                    activeNav={activeNav}
                    handleClassName={handleClassName}
                    isCollapsed={open}
                  />
                ))}
            </Box>
          </Box>

          <Box
            position="relative"
            left={open ? "20px" : "4px"}
            mt="40px"
            paddingBottom={4}
          >
            <Button
              startIcon={<img src={Out} width="20px" height="20px" />}
              color="neutral"
              onClick={onSignOut}
            >
              <Typography ml="8px">
                {open ? data[language].Sidebar.Exit.Title : ""}
              </Typography>
            </Button>
          </Box>
        </React.Fragment>
      ) : (
        <CircularProgress color="warning" />
      )}
    </CustomDrawer>
  );
};

export const Sidebar = React.memo(AppSidebar);
